module.exports = __webpack_public_path__ + "static/media/Wacky Witch.655b7321.jpg";